import { render, staticRenderFns } from "./ReminderPin.vue?vue&type=template&id=10f391e8&scoped=true"
import script from "./ReminderPin.vue?vue&type=script&lang=js"
export * from "./ReminderPin.vue?vue&type=script&lang=js"
import style0 from "./ReminderPin.vue?vue&type=style&index=0&id=10f391e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f391e8",
  null
  
)

export default component.exports
import QPageSticky from 'quasar/src/components/page-sticky/QPageSticky.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPageSticky,QBtn});qInstall(component, 'directives', {TouchPan});
